import { render, staticRenderFns } from "./FooterLanguage.vue?vue&type=template&id=307fb478&"
import script from "./FooterLanguage.vue?vue&type=script&lang=js&"
export * from "./FooterLanguage.vue?vue&type=script&lang=js&"
import style0 from "./FooterLanguage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports